
import { defineComponent } from 'vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'

export default defineComponent({
    name: 'Start',
    components: {
        BackgroundImage,
    },
})
